import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

// Layout
import Layout from './components/layout/Layout'

// Pages
import HomePage from './pages/HomePage'
import VitaPage from './pages/VitaPage'
import WerkePage from './pages/WerkePage'
import AusstellungenPage from './pages/AusstellungenPage'
import KontaktPage from './pages/KontaktPage'
import ImpressumPage from './pages/ImpressumPage'
import DatenschutzPage from './pages/DatenschutzPage'

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="vita" element={<VitaPage />} />
            <Route path="werke" element={<WerkePage />} />
            <Route path="werke/:artworkId" element={<WerkePage />} />
            <Route path="ausstellungen" element={<AusstellungenPage />} />
            <Route path="kontakt" element={<KontaktPage />} />
            <Route path="impressum" element={<ImpressumPage />} />
            <Route path="datenschutz" element={<DatenschutzPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  )
}

export default App
